import { Size } from 'src/types/transforms';

export interface MapPoint {
    sourceX: number;
    sourceY: number;
    targetX: number;
    targetY: number;
}

export const createMapPoint = (): MapPoint => ({
    sourceX: 0,
    sourceY: 0,
    targetX: 0,
    targetY: 0,
});

export const createSize = (width: number = 0, height: number = 0): Size => ({
    width: width,
    height: height,
});

export interface PlacementWarp {
    rotation: number;
    size: Size;
    mapPoint: MapPoint;
}

export const createPlacementWarp = (): PlacementWarp => ({
    rotation: 0,
    size: createSize(),
    mapPoint: createMapPoint(),
});

export interface PerspectiveWarp {
    mapPoints: MapPoint[];
}

export const createPerspectiveWarp = (): PerspectiveWarp => ({
    mapPoints: [],
});

export interface TubeWarp {
    size: Size;
    orientation: string;
    lowShift: number;
    highShift: number;
    mapPoints: MapPoint[];
}

export const createTubeWarp = (): TubeWarp => ({
    size: createSize(),
    orientation: '',
    lowShift: 0,
    highShift: 0,
    mapPoints: [],
});

export interface CylinderWarpOutput {
    documentSize: Size;
    placementWarp?: PlacementWarp;
    perspectiveWarp?: PerspectiveWarp;
    tubeWarp?: TubeWarp;
    decorationAreaPoints?: MapPoint[];
}

export const createCylinderWarpOutput = (): CylinderWarpOutput => ({
    documentSize: createSize(),
    decorationAreaPoints: [],
});
